import React from 'react'
import PropTypes from 'prop-types'
import posed from 'react-pose'
import Button from './Button'
import moment from 'moment'
import Icon from './Icon'
import AnimatedSvg from './AnimatedSvg'
import PosedMountWrapper from '../utils/posed/PosedMountWrapper'

const propTypes = {
  media: PropTypes.object,
  header: PropTypes.string,
  text: PropTypes.string,
  timeLine: PropTypes.object,
  action: PropTypes.shape({
    text: PropTypes.string,
    icon: PropTypes.string,
    variant: PropTypes.variant,
  }),
  onActionClick: PropTypes.func,
  stage: PropTypes.oneOf([
    'error',
    'alreadyCollected',
    'baySelection',
    'arrived',
  ]),
}

const defaultProps = {
  header: '',
  text: '',
  stage: 'start',
}

const PosedWrapper = posed.div({
  start: { opacity: 0, y: '10px' },
  end: {
    opacity: 1,
    staggerChildren: 50,
    delayChildren: 500,
    y: '0px',
    transition: {
      duration: 800,
    },
  },
})

const PosedFooter = posed.div({
  start: { opacity: 0 },
  end: {
    opacity: 1,
    delay: 500,
    transition: {
      duration: 1000,
    },
  },
})

const Card = props => {
  const { header, text, action, onActionClick, timeLine, stage, dataCy } = props

  function renderTimeLine() {
    const { start, end } = timeLine
    const startDateTime = moment(start)
    const endDateTime = moment(end)
    const startTime = startDateTime.format('HH:mm')
    const endTime = endDateTime.format('HH:mm')
    const dayMonth = startDateTime.format('Do MMMM')
    return (
      <div
        data-cy="collection-time"
        className="p-4 mt-6 -m-6 text-sm text-center border-t border-dashed bg-body-lightest border-body-border"
      >
        <span className="font-semibold">Collection time</span>
        <div className="leading-none">
          {dayMonth} &nbsp;
          <span className="inline-block mt-1 text-lg font-semibold">
            <span>{startTime}</span>
            <span> &ndash; </span>
            <span>{endTime}</span>
          </span>
        </div>
      </div>
    )
  }

  return (
    <div data-cy={dataCy}>
      <PosedFooter
        initialPose="start"
        pose="end"
        className="fixed bottom-0 left-0 z-auto w-full shadow-lg bg-body-lightest lg:max-w-lg h-55vh will-change-transform"
      />
      <PosedWrapper
        initialPose="start"
        pose="end"
        className="relative flex flex-col p-6 mb-12 overflow-hidden bg-white rounded-lg shadow-md"
      >
        <div className="relative mb-6 -mx-6 -mt-6 overflow-hidden">
          <AnimatedSvg key="card-header" stage={stage} />
        </div>
        <PosedMountWrapper>
          <h2 className="mb-4 text-2xl font-semibold leading-tight">
            {header}
          </h2>
        </PosedMountWrapper>
        <PosedMountWrapper>
          {text.split('\n').map((item, key) => {
            return (
              <p className="mb-6 text-lg" key={key}>
                {item}
              </p>
            )
          })}
        </PosedMountWrapper>
        {action && (
          <PosedMountWrapper className="mb-2" initialPose="start" pose="end">
            <Button
              variant={action.variant ? action.variant : 'tertiary'}
              onClick={onActionClick}
            >
              <span className="flex items-center justify-center block w-full px-2 text-center">
                <span className="block px-2">{action.text}</span>
                {action.icon && <Icon className="block" icon={action.icon} />}
              </span>
            </Button>
          </PosedMountWrapper>
        )}
        <div>{timeLine && renderTimeLine()}</div>
      </PosedWrapper>
    </div>
  )
}

Card.propTypes = propTypes
Card.defaultProps = defaultProps

export default Card
